/**
 * Die Anfrage der Rückfrage-Karte an die Martin-Route (server/beleg-route.ts). (19.10.2026, Befehlskanal P2)
 * Gesendet wird nur Kennung, Hash des Fragetextes und Ja/Nein, mit dem Pflichtkopf der eigenen Seite (wie die Ja-Knöpfe, lib/blender-freigabe-schalter.ts).
 * Der Beleg selbst kommt nie hierher zurück — nur „ausgestellt, gültig bis“ oder ein fester Fehlercode. `null` = Netz oder unlesbare Antwort.
 */
import { BELEG_FEHLER, BELEG_KOPF_WERT, BELEG_PFAD, type BelegAntwortFehler, type BelegAntwortOk, type BelegFehlerCode } from "../../shared/beleg-wege.js";

export async function fordereBeleg(kennung: string, hash: string, ergebnis: "ja" | "nein"): Promise<BelegAntwortOk | BelegAntwortFehler | null> {
  try {
    const r = await fetch(BELEG_PFAD, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "X-Vespera-Aktion": BELEG_KOPF_WERT },
      body: JSON.stringify({ kennung, hash, ergebnis }),
    });
    const j = (await r.json().catch(() => null)) as { ok?: unknown; error?: unknown; gueltig_bis?: unknown } | null;
    if (!j) return null;
    if (j.ok === true && typeof j.gueltig_bis === "number") return { ok: true, kennung, ergebnis, gueltig_bis: j.gueltig_bis };
    const code = (BELEG_FEHLER as readonly string[]).includes(String(j.error)) ? (j.error as BelegFehlerCode) : "nicht-bereit";
    return { ok: false, error: code };
  } catch {
    return null;
  }
}
